/**
 * Off-site destinations the presentation supplies (FNO-DEMO-END): the game's itch.io page, where the project posts its
 * updates, and the site's home page. Absolute, so they are the same in dev, in preview and in the deployed game.
 * The home page's own links come from registry.site; the itch.io link there is a presentation constant like the
 * NASA-guidelines and GitHub destinations (scripts/lib/site.ts), so registry.site is unchanged.
 */
export const ITCH_URL = 'https://danleeodinson.itch.io/failure-is-not-an-option';
export const SITE_HOME_URL = 'https://finaogame.com/';
